package com.gloopgo.game.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Color

data class GameCanvasColors(
    val arenaBackground: Color,
    val gridLines: Color,
    val arenaBorder: Color,
    val hudBackground: Color,
    val hudTextPrimary: Color,
    val hudTextSecondary: Color,
    val hudAccent: Color
)

val LocalGameCanvasColors = staticCompositionLocalOf {
    DarkGameCanvasColors
}

val DarkGameCanvasColors = GameCanvasColors(
    arenaBackground = Color(0xFF10141D),
    gridLines = Color(0xFF1E2536),
    arenaBorder = Color(0xFFFF5252),
    hudBackground = Color(0x99000000),
    hudTextPrimary = Color(0xFFFFFFFF),
    hudTextSecondary = Color(0xFF94A3B8),
    hudAccent = Color(0xFF00E5FF)
)

private val DarkColorScheme = darkColorScheme(
    primary = Color(0xFF00E5FF),
    secondary = Color(0xFF00E676),
    tertiary = Color(0xFFFF9100),
    background = Color(0xFF0F172A),
    surface = Color(0xFF1E293B),
    onPrimary = Color.Black,
    onSecondary = Color.Black,
    onBackground = Color.White,
    onSurface = Color.White
)

@Composable
fun GloopGoTheme(
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(LocalGameCanvasColors provides DarkGameCanvasColors) {
        MaterialTheme(
            colorScheme = DarkColorScheme,
            content = content
        )
    }
}
